import { AnimatePresence, motion, Variants } from "framer-motion";
import { AnimationDefinition } from "framer-motion/types/render/utils/animation";
import styled from "styled-components";
import { ImageConfig } from "../models/client";
// import { InteractionTransitionConfig } from "../models/api/Interaction";
import { easings, fill } from "../styles/utils";

interface InteractionTransitionProps {
  imgStart: ImageConfig;
  imgEnd: ImageConfig;
  selected: boolean;
  onAnimationStart?: () => any;
  onAnimationEnd?: () => any;
  onInteractionStart?: () => any;
  onInteractionComplete?: () => any;
}

const Wrapper = styled(motion.div)`
  ${fill()};
  pointer-events: none;
`;

const transitionVariants: Variants = {
  initial: (variant) => {
    switch (variant) {
      case "in":
        return {
          scale: 0.5,
          opacity: 0,
        };
      default:
        return {
          scale: 1.6,
          opacity: 0,
        };
    }
  },
  animate: (variant) => {
    switch (variant) {
      case "in":
        return {
          scale: 1,
          opacity: 1,
          transition: { duration: 1.2, delay: 1.6, ease: easings.easeOutCubic },
        };
      default:
        return {
          scale: 1,
          opacity: 1,
          transition: { duration: 1.2, delay: 1.6, ease: easings.easeOutCubic },
        };
    }
  },
  exit: (variant) => {
    switch (variant) {
      case "in":
        return {
          scale: 1.2,
          opacity: 0,
          transition: { duration: 1.2, ease: easings.easeInCubic },
        };
      default:
        return {
          scale: 0.8,
          opacity: 0,
          transition: { duration: 1.2, ease: easings.easeInCubic },
        };
    }
  },
};

const Image = styled.img`
  ${fill()}
  cursor: none;
  pointer-events: none;
`;

const MotionImageContainer = styled(motion.div)`
  ${fill()}
  pointer-events: none;
`;

export const InteractionTransition: React.FC<InteractionTransitionProps> = ({
  imgStart,
  imgEnd,
  selected,
  onAnimationStart,
  onAnimationEnd,
  onInteractionStart,
  onInteractionComplete,
  children,
}) => {
  const handleOpenAnimationStart = (def: AnimationDefinition) => {
    if (def === "animate") {
      console.log("open start");
      onAnimationStart && onAnimationStart();
      onInteractionStart && onInteractionStart();
    }
  };
  const handleOpenAnimationComplete = (def: AnimationDefinition) => {
    if (def === "animate") {
      onAnimationEnd && onAnimationEnd();
    }
  };
  const handleCloseAnimationStart = (def: AnimationDefinition) => {
    if (def === "animate") {
      onAnimationStart && onAnimationStart();
    }
  };
  const handleCloseAnimationComplete = (def: AnimationDefinition) => {
    if (def === "animate") {
      onAnimationEnd && onAnimationEnd();
      onInteractionComplete && onInteractionComplete();
    }
  };

  return (
    <Wrapper>
      <AnimatePresence initial={false}>
        {!selected ? (
          <MotionImageContainer
            key="open"
            initial="initial"
            animate="animate"
            exit="exit"
            custom={"in"}
            variants={transitionVariants}
            onAnimationStart={handleCloseAnimationStart}
            onAnimationComplete={handleCloseAnimationComplete}
          >
            <Image src={imgEnd.src}></Image>
          </MotionImageContainer>
        ) : (
          <MotionImageContainer
            key="closed"
            initial="initial"
            animate="animate"
            exit="exit"
            custom={"out"}
            variants={transitionVariants}
            onAnimationStart={handleOpenAnimationStart}
            onAnimationComplete={handleOpenAnimationComplete}
          >
            <Image src={imgEnd.src}></Image>
          </MotionImageContainer>
        )}
      </AnimatePresence>
    </Wrapper>
  );
};
